import { IAtMediaProps } from './at-media.types';

export const atMediaMockData: IAtMediaProps = {
  roundedCorners: '2xl',
  src: {
    mobile: '/assets/bg_house.png',
    tablet: '',
    desktop: '',
  },
  alt: 'atMedia mock data',
  className: 'z-10',
};
